<template>
    <div class="c-footer" v-if="lead.dealer_id">
        <div class="c-footer__content">
            Potrzebujesz pomocy?&nbsp; &nbsp;<a :href="'tel:' + (getDealers && lead.dealer_id? ' '+getDealers.find(e => e.id == lead.dealer_id).phone_number:'')">{{ getDealers && lead.dealer_id? ' '+getDealers.find(e => e.id == lead.dealer_id).phone_number:'' }}</a>&nbsp; &nbsp;<a :href="'mailto:'+(getDealers && lead.dealer_id? ' '+getDealers.find(e => e.id == lead.dealer_id).email:'')">{{ getDealers && lead.dealer_id? ' '+getDealers.find(e => e.id == lead.dealer_id).email:'' }}</a>
        </div>
        <div class="c-footer__bottom">
            <div>
                <a href="https://wroclaw.bmw-inchcape.pl/polityka-prywatnosci" target="_blank">Ochrona danych</a> | 
                <a href="https://wroclaw.bmw-inchcape.pl/polityka-cookies" target="_blank">Pliki cookie</a> |
                <a href="https://wroclaw.bmw-inchcape.pl/nota-prawna" target="_blank">Informacje prawne</a>
            </div>
            <div class="c-footer__copy">
                Webwizards 
            </div>
        </div>
    </div>
</template>
<script>

    import { mapGetters } from 'vuex';
    import lead from '../mixins/lead.js';

    export default {
        mixins:[lead],
        computed:{
            ...mapGetters({
                getDealers:'definitions/getDealers'
            })
        }
    }
</script>
<style lang="scss">
    .c-footer{
        width: 100%;
        &__content{
            font-size: 1.25rem;
            color: $white;
            text-align: center;
            background-color: $gray;
            display: flex;
            justify-content: center;
            align-items: center;
            min-height: 68px;
            a{
                color: $white;
            }
        }
        &__bottom{
            font-weight: bold;
            max-width: 1225px;
            padding: 2rem;
            margin: 0 auto;
            a{
                color: $black;
            }
            @media(min-width: 960px){
                display: flex;
                justify-content: space-between;
            }
        }
        &__copy{
            color: $gray;
            font-weight: normal;
        }
    }
</style>
